import './index.css';
import { useContext, useEffect, useState } from 'react';
import CustomerCallChat from '../../components/CustomerCallChat';
import CustomerCallContainer from '../../components/CustomerCallContainer';
import ChatStore from '../../stores/ChatStore';
import EndCallByTechForCustomer from '../../components/EndCallByTechForCustomer';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import MainStore from '../../stores/MainStore';

export default function CustomerCallView() {

  const { showModalAlert } = useContext(ModalAlertContext);
  const [chatIsOpen, setChatIsOpen] = useState(false);
  const [client, setClient] = useState(null);

  useEffect(() => {
    MainStore.setShowModalAlert(showModalAlert);
  }, []);

  const handleChatIsOpen = () => {
    setChatIsOpen(!chatIsOpen);
    ChatStore.setUnreadMessages(0);
  }

  return (
    <div className="customer-call-view">
      <CustomerCallContainer handleChatIsOpen={handleChatIsOpen} chatIsOpen={chatIsOpen} setChatIsOpen={setChatIsOpen} setClient={setClient} />
      {chatIsOpen && <CustomerCallChat handleChatIsOpen={handleChatIsOpen} />}
      <EndCallByTechForCustomer client={client} />
    </div>
  );
}